import React, { useEffect, useState } from "react";

export default function Welcome() {
  useEffect(() => {
    window.location.href = "./home.html";
  }, []);

  return null; // Retorna null para não renderizar nada na tela
}
